export interface IArticle {
  id: number
  title: string
  category: string
  totalView: string
  active: string
}

export interface ICategoryList {
  id: number
  category_name: string
  user_id: number
  created_at: string
}

export interface IArticleList {
  id: number
  title: string
  description: string
  category_name: string
  user_name: string
  category_id: number
}

export interface PartialArticleWithDate extends Partial<IArticleList> {
  created_at: string
}
export interface IArticleAddForm {
  title: string
  description: string
  category: number | null
  categoryName: string
}

export interface IArticleParams {
  page: number
  size: number
  category: number
}

export interface ICategoryCount {
  total: number
  category_id: number
  category_name: string
}

export const initArticleAddFormValues: IArticleAddForm = {
  title: '',
  description: '',
  category: null,
  categoryName: '',
}
